<script setup>
import { ref, defineProps, defineEmits } from 'vue'
import MenuButton from './Components/Menu-Button.vue'
import ModalButtons from './Components/Modal-Menue.vue'
import DataView from './Components/Data-View.vue'
import { isValidURL } from '@/core/var/tools'

// local variables
const editHtmlDialog = ref(false)
const BLOCK_NAME = "video_url";

// define props
const props = defineProps({
    template_type: { type: String, required: true },
    index: { type: Number, required: false },
    data: { type: Object, required: true },
    workflow_id: { type: String, required: false },
    image_library: { type: Object, required: false },
})
// define emits
const emits = defineEmits(['blockCallback'])

// fields
const text_video_url = ref(props.data.text_video_url)
const template = ref(BLOCK_NAME)

// functions
const edit_block = () => {
    editHtmlDialog.value = true
}

const save_block = () => {
    emits('blockCallback',
        {
            "template_data": {
                "template": template.value,
                "text_video_url": text_video_url.value,
            },
            "action": "save",
            "index": props.index
        }
    )
    editHtmlDialog.value = false
}

const delete_block = () => {
    emits('blockCallback',
        {
            "action": "delete",
            "index": props.index
        }
    )
    editHtmlDialog.value = false
}

const add_block = () => {
    emits('blockCallback',
        {
            "template_data": {
                "template": template.value,
                "text_video_url": "",
            },
            "action": "add",
            "index": props.index
        }
    )
}

const toggleDialog = () =>{
    editHtmlDialog.value = false
}

</script>

<template>
    <!--------------------------------------------------->
    <!------------------ Menu View ---------------------->
    <!--------------------------------------------------->
    <MenuButton v-if="props.template_type == 'menu'" :add_block="add_block" button="pi-video" name="Video URL" />

    <!--------------------------------------------------->
    <!------------------ Data View ---------------------->
    <!--------------------------------------------------->
    <DataView v-if="props.template_type == 'data'" :edit_block="edit_block" name="Video URL">
        <div v-if="isValidURL(text_video_url)" class="flex justify-center items-center p-6 m-4">
            <video controls class="mx-auto">
                <source :src="text_video_url" type="video/mp4">
                Your browser does not support the video tag.
            </video>
        </div>
        <div v-else class="h-24 flex justify-center items-center">
            Select video file
        </div>
    </DataView>
    <!--------------------------------------------------->
    <!------------------- Dialogs ----------------------->
    <!--------------------------------------------------->
    <Dialog v-model:visible="editHtmlDialog" :style="{ width: '80%' }" header="Block bearbeiten" :modal="true" class="p-fluid">
        <div class="">
            <ModalButtons :saveBlock="save_block" :deleteBlock="delete_block" :toggleDialog="toggleDialog" />
            <div class="my-3">
                <InputText v-model="text_video_url" class="w-full" placeholder="https://" />
            </div>
        </div>
    </Dialog>
</template>